import React from 'react';
import { RandomCssDemo } from './RandomCssDemo';
import { makeDivs } from './utils';

const SHAKY_GRID_HTML = `<div class="vertical">${makeDivs(16, 'line')}</div>
<div class="horizontal">${makeDivs(20, 'line')}</div>`;

export function ShakyGridExample() {
  return (
    <RandomCssDemo
      title="Shaky Grid"
      showLoadButton={false}
      htmlBody={SHAKY_GRID_HTML}
      scaffoldCss={`
        * { box-sizing: border-box; }
        body {
          position: absolute;
          margin: 0;
          inset: 0;
          background: #e9e0cb;
          overflow: hidden;
          display: flex;
          align-items: stretch;
          justify-content: flex-start;
        }
          .vertical {
  display: flex;
  position: absolute;
  inset: 0;
  overflow: clip;
  align-items: stretch;
  justify-content: space-around;
}

.horizontal {
  display: flex;
  position: absolute;
  flex-direction: column;
  inset: 0;
  overflow: clip;
  align-items: stretch;
  justify-content: space-around;
}

.line {width:100%;
  background: #000a;}
      `}
      cssCodeInit={`.line {
  transform:
    scale(1.5)
    rotate(random(-10deg, 10deg))
    skew(random(-10deg, 10deg), random(-10deg, 10deg));
}
.vertical .line {
  width: random(5px, 10px);
}

.horizontal .line {
  height: random(5px, 10px);
}`}
    />
  );
}
